import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useEnterpriseAuth } from "@/enterprise/hooks/useEnterpriseAuth";

export default function RequireOrgMember({ children }: { children: React.ReactNode }) {
  const { status, isOrgMember } = useEnterpriseAuth();
  const loc = useLocation();

  if (status === "loading") {
    return (
      <div className="min-h-[40vh] grid place-items-center text-white">
        <div className="px-4 py-2 rounded-xl border border-white/10 bg-white/5">Authorizing…</div>
      </div>
    );
  }
  if (status === "signed-out") {
    return <Navigate to={`/enterprise/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  }
  if (!isOrgMember) {
    return <Navigate to={`/enterprise/login?err=not_member&next=${encodeURIComponent(loc.pathname)}`} replace />;
  }
  return <>{children}</>;
}
